'use strict';

module.exports = {
  BRAINTREE_API_VERSION_HEADER: '2017-04-03'
};
